import { render } from "./ServiceComp.vue?vue&type=template&id=74dae9dd"
import script from "./ServiceComp.vue?vue&type=script&lang=js"
export * from "./ServiceComp.vue?vue&type=script&lang=js"

import "./ServiceComp.vue?vue&type=style&index=0&id=74dae9dd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__